import styles from './PageTitle.module.css';
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

export default function PageTitle({ title, image }) {

  return (
    <div
      className={cx('pageTitleWrap')}
      style={{
        backgroundImage : `url(${image})`
      }}
    >
      <div className={cx("overlay")} />
      <h3>{title}</h3>
    </div>
  );
}